<template>
     <v-container>
        <v-card style="border-radius: 8px;">
            <v-container>
                <v-layout class="ml-2">
                    <v-flex xs3>
                            <v-card-title>
                                <h2 class="font-weight-regular">Create Refs</h2>
                            </v-card-title>
                    </v-flex>             
                    <v-flex xs4>
                        <v-select
                            item-text="name"
                            label="Response"
                            :items="cresponses" 
                            placeholder="select the response"
                            v-model="response"
                            return-object            
                        ></v-select>
                        <v-text-field
                            label="Ref code"
                            v-model="response.ref"
                            hint="Changing existing value may affect the previous usage"
                            persistent-hint                             
                            counter="2083"             
                        ></v-text-field>
                             <v-btn class="mt-5" @click="updateref" flat round color="primary">Update Ref</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout class="ml-2">
                    <v-flex xs3>
                        <v-card-title>
                            <h2 class="font-weight-regular">Refs usage</h2>
                        </v-card-title>
                    </v-flex>
                    <v-flex>                        
                        <v-card-title>
                            <div>
                            <h3 class="font-weight-regular">1. Used in short links</h3>
                            <div class="grey--text">Use this short URL (m.me/{{refid}}?ref={{response.ref}}) to redirect to the Response</div>
                            </div>
                        </v-card-title>
                         <v-card-title>
                            <div>
                            <h3 class="font-weight-regular">2. Used in QR codes </h3>
                            <div class="grey--text">Generate QR code for the ref to redirect to the Response</div>
                            </div>
                        </v-card-title>
                         <v-card-title>
                            <div>
                            <h3 class="font-weight-regular">3. Used in web plugins</h3>
                            <div class="grey--text">Used in plugins to track and redirect to the Response</div>
                            </div>
                        </v-card-title>
                    </v-flex>
                </v-layout>
            </v-container>    
        </v-card>
     </v-container>            
</template>

<script>
export default {
    data(){
        return{
            response:{}
        }
    },
    methods:{
        updateref(){
            let docId = this.response.id
            let ref = this.response.ref
            this.$store.dispatch('aupdateref', {docId,ref})
        }
    },
    computed:{
        cresponses(){
            return this.$store.state.responses
        },
        refid(){
            if(this.$store.state.pageDetails.username == undefined){
               return this.$store.state.pageDetails.page_id
            }
            else{
                return this.$store.state.pageDetails.username
            }
        }
    }

}
</script>

<style>

</style>
